/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_Feature_5Inputs */

const et_plan_visibility_feature_5 = /** @type {(inputs: Plan_Visibility_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tead lihtsas keeles, mida parandati ja miks see oluline on`)
};

const en_plan_visibility_feature_5 = /** @type {(inputs: Plan_Visibility_Feature_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You know in simple language what was improved and why it matters`)
};

/**
* | output |
* | --- |
* | "You know in simple language what was improved and why it matters" |
*
* @param {Plan_Visibility_Feature_5Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_feature_5 = /** @type {((inputs?: Plan_Visibility_Feature_5Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_Feature_5Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_feature_5(inputs)
	return en_plan_visibility_feature_5(inputs)
});